import {getLastElementOr, showlog} from "../../utils";
import moment from "moment";
import {sha256} from "js-sha256";
import {loadLastVersion, loadMagnitudeOrders, loadOrders, sendImageData} from "./order-service";


export const searchOrders = (
	{search, from, to, page}   // search
) => {

	let appDbPrefix ="mobileagent";

	let before = to || 0;
	let after = from || 0;

	return (
		loadOrders( appDbPrefix, (before * 1), (after * 1), search, page )
			.then( list => list.data )
			.then( list => (
				list =
					list
						.sort( (x: any, y: any) => {
							if( x.moment < y.moment ) return 1;
							return -1;
						})
						.map( liveOrder => {
							if( !!liveOrder.payload ) {
								/*
								id: "id",
								_id: "dbID",
								operatorId: "opID",
								operatorUsername: "Agente",
								operatorSyncUrl: "syncURL",
								customer: "Customer",
								itemsMagnitude: "Articles",
								deliveryDate: "Consegna",
								device: "Device"
								 */
								liveOrder.operatorId = liveOrder.payload.agente;
								liveOrder.operatorUsername = !!liveOrder.agent ? liveOrder.agent.name : "no-agent";
								liveOrder.group = (!!liveOrder.agent) ? liveOrder.agent.group : "";
								liveOrder.operatorSyncUrl = !!liveOrder.agent ? liveOrder.agent.syncUrl : "no-url";
								liveOrder.customer = liveOrder.payload.customer ? liveOrder.payload.customer.ragioneSociale : 'NO-CUSTOMER';
								liveOrder.itemsMagnitude = liveOrder.payload.items.length;
								liveOrder.deliveryDate = liveOrder.payload.deliveryDate;
								liveOrder.device = !!liveOrder.device ? (liveOrder.device.brand +" "+ liveOrder.device.model) : "no-device";
							}
							else {
								liveOrder.operatorId = 0;
								liveOrder.operatorUsername = !!liveOrder.agent ? liveOrder.agent.name : "no-agent";
								liveOrder.group = (!!liveOrder.agent) ? liveOrder.agent.group : "";
								liveOrder.operatorSyncUrl = !!liveOrder.agent ? liveOrder.agent.syncUrl : "no-url";
								liveOrder.customer = "";
								liveOrder.itemsMagnitude = 0;
								liveOrder.deliveryDate = "";
								liveOrder.device = !!liveOrder.device ? (liveOrder.device.brand +" "+ liveOrder.device.model) : "no-device";
							}

							// arriva una stringa
							let lastSyncRaw =
								!!liveOrder.lastSync
									? liveOrder.lastSync
									: '{ "dateTime": 0 }'
							;
							let lastSync = 0;
							try {
								lastSync = JSON.parse( lastSyncRaw ).dateTime;
							}
							catch (e) {
								// è già un oggetto e il JSON parse va in errore
								lastSync = lastSyncRaw.dateTime;
							}

							liveOrder.moment = moment.unix( liveOrder.moment / 1000 ).format("DD/MM/YYYY HH:mm:ss")
							liveOrder.companyName = (!!liveOrder.company) ? liveOrder.company.name : "";
							liveOrder.lastSync = moment.unix( lastSync / 1000 ).format("DD/MM/YYYY HH:mm:ss");
							liveOrder.ipv4 = liveOrder.ipv4;
							// liveOrder.companyPicUrs = liveOrder.company.name;


							return liveOrder;
						})

						// fields sort
						.map( liveOrder => {
							return (
								Object.assign(
									{},
									{
										id: liveOrder.id,
										_id: liveOrder._id,
										numDocOriginale: liveOrder.payload.NumDocOriginale || liveOrder.payload.docId || liveOrder.payload.NumeroDocumentoOriginale,
										moment: liveOrder.moment,
										operatorId: liveOrder.operatorId,
										companyName: liveOrder.companyName,
										operatorUsername: liveOrder.operatorUsername,
										group: liveOrder.group,
										operatorSyncUrl: liveOrder.operatorSyncUrl,
										customer: liveOrder.customer,
										itemsMagnitude: liveOrder.itemsMagnitude,
										deliveryDate: liveOrder.deliveryDate,
										device: liveOrder.device,
										appVersion: !!liveOrder.appVersion ? liveOrder.appVersion : ""
									},
									liveOrder
								)
							);
						})

				// .filter((_, index) => index < 2)

			))
			.catch( e => Promise.reject( e ))
	);
}

export const searchMagnitudeOrders = (
	{search, from, to, page}   // search
) => {

	let appDbPrefix ="mobileagent";

	let before = to || 0;
	let after = from || 0;

	return (
		loadMagnitudeOrders( appDbPrefix, (before * 1000), (after * 1000), search, page )
			.then( magnitude => (

				magnitude

			))
			.catch( e => Promise.reject( e ))
	);
}

export const getLastVersion = () => {
	let appDbPrefix ="mobileagent";
	return (
		loadLastVersion( appDbPrefix )
			.then( (result: any) => result.data )
			.catch((e: any) => Promise.reject( e ))
	)
};


export const uploadImages = (companyName, syncUrl, codArt, mimeType, content) => {
	let appDbPrefix ="mobileagent";
	let imageCode = sha256( syncUrl + codArt );
	return sendImageData(appDbPrefix, companyName, codArt, mimeType, content, imageCode);
}


export const retrieveImages = (token, group, syncUrl, companyName) => {


	return (
		new Promise<any>((onEnd, onFail) => {

			if(!!token && !!group) {

				// apertura canale
				fetch(
					syncUrl +"/mobileagent/api/websocket/starter",
					{
						method: "GET",
						headers: {
							// Authorization: token
						}
					}
				)
					.then( response => response.text())
					.then( response => {

						showlog("preparing to open channel to connector's customer");


						let channelUrl =
							syncUrl                         // http://urlpath:8081/
								.split(":")                 // [http, //urlpath, 8081/]
								.reverse()                  // [8081/, //urlpath, http]
								.filter((p, i) => i > 0)    // [//urlpath, http]
								.reverse()                  // [http, //urlpath]
								.filter((p, i) => i > 0)    // [//urlpath]
								.join(":")                  // //urlpath
						;
						channelUrl = "ws://"+ channelUrl +":8085";  // TODO la porta non è fissa
						let channel = new WebSocket( channelUrl );


						let imageChannelRequest = {
							token: [
								token,
								group
							].join("-"),
							action: "getImages",
							dateTime: moment().toISOString(true)
						};
						showlog("richiesta canale", imageChannelRequest);

						// debugger;


						channel.onopen = result => {
							channel.send( JSON.stringify( imageChannelRequest ) );
						}


						channel.onmessage = message => {
							showlog("ricezione dati immagini");
							/*
							{
								"status": "OK",
								"metadata": {
									"app_version": 2092009,
									"connectionId": "7b91fc1a-2d9b-426d-834a-03384af1702f",
									"tableName": "IMMAGINI",
									"target": "ALL",
									"totalRows": 69,
									"generalTotalRows": 69,
									"currentRows": 1,
									"totalPieces": 69,
									"currentPiece": 1,
									"rangePieces": 1,
									"lastPiece": 1,
									"articleId": "BAGRS5",
									"foreignKeysList": null
								},
								"data": {
									"toAll": [
										{
											"mymeType": "application/jpg",
											"fileString": "4WGEjooAKKKK...AH/9k=",
											"defaultImage": true,
											"articleId": "BAGRS5",
											"url": "\\\\ServerTest\\Images\\articoli\\14.jpg"
										}
									],
									"toAdd": null,
									"toAddUpdate": null,
									"toUpdate": null,
									"toDelete": null
								},
								"lastUpdate": null,
								"date": "2023/03/17 11:30"
							}
							 */
							try {
								let objPayload = JSON.parse( message.data );


								if( !!objPayload.data && !!objPayload.data.toAll && !!objPayload.data.toAll[0] /*&& (article.codice === objPayload.data.toAll[0].articleId)*/ ) {

									uploadImages( companyName, syncUrl, objPayload.data.toAll[0].articleId, objPayload.data.toAll[0].mymeType, objPayload.data.toAll[0].fileString);

								}

								if( !!objPayload.metadata && (objPayload.metadata.totalPieces == objPayload.metadata.currentPiece) ) {
									onEnd( undefined );
								}

							}
							catch (e) {
								showlog("errore al parse della risposta");
								showlog( e );
								// debugger;
								onFail( e );
							}

						}


					})
					.catch( e => {
						showlog("erore all'apertura del canale");
						showlog( e );
						// debugger;
						onFail( e );
					})



			}
			else {
				// debugger;
				onFail();
			}
		})
	)

}
